import React from "react";
import { STEP_BACKGROUND } from "./sections";

/**
 * Horizontal "Speak → Transcribe → Refine" pipeline used by the workflow and
 * comparison sections.
 *
 * `tone` switches the chip surface: "neutral" sits on white, "onTint" sits on
 * the #EBF7FE panel. A step marked `solid` renders as the filled blue endpoint.
 * The row wraps on narrow screens so a five-step flow never forces a
 * horizontal scroll.
 */
const FlowSteps = ({ steps, tone = "neutral", accentArrows = false }) => {
  const chipBase =
    "inline-flex items-center rounded-[8px] px-[12px] py-[7px] font-jakarta text-[12.5px] sm:text-[13px] font-semibold leading-[18px] tracking-[0px] whitespace-nowrap";

  // "neutral" chips share the step surface used by the pipeline in
  // "What AI voice typing really is"; "onTint" chips sit on the blue panel.
  const chipTone =
    tone === "onTint"
      ? "bg-white text-[#0A0D16] border-[1px] border-[#3AB1F61F]"
      : "text-[#3AB1F6]";

  const chipStyle =
    tone === "onTint" ? undefined : { background: STEP_BACKGROUND };

  return (
    <div className="flex flex-wrap items-center gap-x-[8px] gap-y-[8px]">
      {steps.map(({ label, solid }, index) => (
        <React.Fragment key={label}>
          {index > 0 && (
            <span
              aria-hidden="true"
              className={`select-none text-[13px] leading-[18px] ${
                accentArrows ? "text-[#3AB1F6]" : "text-[#0A0D1666]"
              }`}
            >
              &#8594;
            </span>
          )}

          <span
            style={solid ? undefined : chipStyle}
            className={`${chipBase} ${
              solid
                ? "bg-gradient-to-r from-[#3AB1F6] to-[#407BFF] text-white border-transparent"
                : chipTone
            }`}
          >
            {label}
          </span>
        </React.Fragment>
      ))}
    </div>
  );
};

export default FlowSteps;
